/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgThumbsUpSolid = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.15 1.323.027-.073h.573c.99 0 1.795.958 1.495 1.938l-.782 2.562H13.5a1.25 1.25 0 0 1 .7 2.286c.185.181.3.434.3.714v.125c0 .397-.206.746-.516.946a.997.997 0 0 1 .266.679v.125c0 .486-.308.9-.74 1.057.152.184.24.42.24.693 0 .35-.145.64-.383.837a1.352 1.352 0 0 1-.867.288H8.462l-2.712-.835V5.728c.389-.067.769-.287 1.134-.617.441-.399.838-.938 1.172-1.49a13.331 13.331 0 0 0 .99-2.019c.018-.043.07-.189.104-.28ZM4.75 5H2v8.5h2.75V5Z"
}));

export default SvgThumbsUpSolid;